const consultingreview = {
    getlist: 'consultingreview/getlist-by-admin',
    get: 'consultingreview/get-by-admin',
    accept: 'consultingreview/accept',
    reject: 'consultingreview/reject',
    remove: 'consultingreview/remove',
}
export default consultingreview
